import { Link, TextFieldProps, useRecordContext } from "react-admin";

export const EventNameField = <RecordType extends Record<string, any> = Record<string, any>>(
    _props: TextFieldProps<RecordType>
) => {
    const event = useRecordContext();
    const eventPage = `/events/${event.id}/show`;

    return <Link to={eventPage}>{event.name}</Link>;
};